import React from "react";

const HowWeHelp = () => {
  return (
    <div>
      <h1 className="text-center" style={{ color: "#2f3778" }}>
        How can we help you?
      </h1>
    </div>
  );
};

export default HowWeHelp;
